import { Button, Input } from 'semantic-ui-react';
import styled from 'styled-components';
import FlexBox from '../FlexBox';

const CustomFlexBox = styled(FlexBox)`
	justify-content : space-between;
	padding-bottom: 15px;
`;

const CustomButton = styled(Button)`
	width: 300px;
`;

const PageNumberInput = styled(Input)`
	width: 80px;
	margin: 0 5px;
`;

function Pagination({ page_count, page_index, can_next_page, can_previous_page, previousPage, nextPage, gotoPage }) {
	function handleInputChange(e) {
		const page = e.target.value ? Number(e.target.value) - 1 : 0;
		gotoPage(page);
	}

	function handleNextPrevious(next = true) {
		const input         = document.querySelector(`.page-number input`);
		const current_value = Number(input.value);
		let value           = null;

		if(next) {
			nextPage();
			value = current_value + 1;
		}
		else {
			previousPage();
			value = current_value - 1;
		}

		input.value = value;
	}

	return (
		<CustomFlexBox>
			<CustomButton onClick={() => handleNextPrevious(false)} disabled={!can_previous_page}>Previous</CustomButton>
			<span>Page <PageNumberInput className="page-number" type="number" size="small" defaultValue={page_index + 1} onBlur={handleInputChange} /> of {page_count}</span>
			<CustomButton onClick={() => handleNextPrevious()} disabled={!can_next_page}>Next</CustomButton>
		</CustomFlexBox>
	)
}

export default Pagination;
